declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

export function pushGtmEvent(
  event: string,
  params: Record<string, unknown> = {},
): void {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
}

const PENDING_SIGNUP_METHOD_KEY = "zoe.gtm.pending_signup_method";

export function parkPendingSignup(method: "google" | "email"): void {
  try {
    window.sessionStorage.setItem(PENDING_SIGNUP_METHOD_KEY, method);
  } catch {
    /* Storage unavailable — lose the attribution, not the sign-up */
  }
}

export function redeemPendingSignup(): void {
  try {
    const method = window.sessionStorage.getItem(PENDING_SIGNUP_METHOD_KEY);
    if (!method) return;
    window.sessionStorage.removeItem(PENDING_SIGNUP_METHOD_KEY);
    pushGtmEvent("sign_up", { method });
  } catch {
    /* ditto */
  }
}

export function clearPendingSignup(): void {
  try {
    window.sessionStorage.removeItem(PENDING_SIGNUP_METHOD_KEY);
  } catch {
    /* ditto */
  }
}
